export const CHAT_TYPES = {
  TEXT: "Văn bản",
  ICON: "Icon",
};

export const CHAT_STATUSES = {
  LOCK_ACCOUNT: "Khóa tài khoản",
  MUTE_CHAT: "Cấm chat",
};

export const CHAT_TABLE_COLUMNS = [
  { name: "CharacterName", label: "Tên nhân vật" },
  { name: "Level", label: "Cấp" },
  { name: "Faction", label: "Môn phái" },
  { name: "Type", label: "Loại" },
  { name: "Content", label: "Nội dung cuộc trò chuyện" },
  { name: "CreatedDate", label: "Thời gian" },
  { name: "Status", label: "Trạng thái" },
];

export const CHAT_FAKE_DATA = [
  {
    id: 1,
    CharacterName: "Phong Vân",
    Level: 89,
    Faction: "Thiên nhẫn",
    Type: CHAT_TYPES.TEXT,
    Content: "Hẹn nhau ở Biện Kinh sau giờ công thành.",
    CreatedDate: "2026-06-10T08:30:00+07:00",
    Status: CHAT_STATUSES.MUTE_CHAT,
  },
  {
    id: 2,
    CharacterName: "Kiếm Tâm",
    Level: 102,
    Faction: "Võ đang",
    Type: CHAT_TYPES.ICON,
    Content: "Gửi biểu tượng khiêu chiến trong kênh thế giới.",
    CreatedDate: "2026-06-10T09:12:00+07:00",
    Status: CHAT_STATUSES.LOCK_ACCOUNT,
  },
  {
    id: 3,
    CharacterName: "Ảnh Vũ",
    Level: 76,
    Faction: "Đường môn",
    Type: CHAT_TYPES.TEXT,
    Content: "Mua bán vật phẩm hiếm, giao dịch tại Lâm An.",
    CreatedDate: "2026-06-10T10:05:00+07:00",
    Status: CHAT_STATUSES.MUTE_CHAT,
  },
  {
    id: 4,
    CharacterName: "Tuyết Nhi",
    Level: 95,
    Faction: "Thúy yên",
    Type: CHAT_TYPES.ICON,
    Content: "Spam biểu tượng trong bang hội.",
    CreatedDate: "2026-06-10T10:48:00+07:00",
    Status: CHAT_STATUSES.MUTE_CHAT,
  },
  {
    id: 5,
    CharacterName: "Hỏa Long",
    Level: 110,
    Faction: "Thiên nhẫn",
    Type: CHAT_TYPES.TEXT,
    Content: "Nội dung chat vi phạm quy định cộng đồng.",
    CreatedDate: "2026-06-10T11:22:00+07:00",
    Status: CHAT_STATUSES.LOCK_ACCOUNT,
  },
  {
    id: 6,
    CharacterName: "Thanh Phong",
    Level: 68,
    Faction: "Võ đang",
    Type: CHAT_TYPES.TEXT,
    Content: "Tìm tổ đội vượt ải cuối ngày.",
    CreatedDate: "2026-06-10T12:00:00+07:00",
    Status: CHAT_STATUSES.MUTE_CHAT,
  },
  {
    id: 7,
    CharacterName: "Độc Cô",
    Level: 121,
    Faction: "Đường môn",
    Type: CHAT_TYPES.ICON,
    Content: "Gửi icon liên tục trong kênh chung.",
    CreatedDate: "2026-06-10T13:16:00+07:00",
    Status: CHAT_STATUSES.LOCK_ACCOUNT,
  },
  {
    id: 8,
    CharacterName: "Băng Tâm",
    Level: 84,
    Faction: "Thúy yên",
    Type: CHAT_TYPES.TEXT,
    Content: "Nhắc lịch tham gia hoạt động bang.",
    CreatedDate: "2026-06-10T14:40:00+07:00",
    Status: CHAT_STATUSES.MUTE_CHAT,
  },
];
